export const TRAFFIC_SIM_PAGE_NAME = {
    FEEDPOINTS: "feedpoints",
    LIMITATIONS: 'limitations',
    ADD_LIMITATION: "addLimitation",
    RESERVE_FEEDPOINTS: "reserveFeedpoints",
    UPCOMING_LIMITATION: "upcomingLimitations",
    HISTORY: "history"
}
